import React from 'react';
import AdminMissionsOverview from '@/components/admin/missions/AdminMissionsOverview';

const AdminMissionsPage = () => {
  return <AdminMissionsOverview />;
};

export default AdminMissionsPage;
